import React from "react";
import Typography from "@material-ui/core/Typography/Typography";

interface IChartTitleProps {
    title?: string;
    secondaryTitle?: string;
}

const ChartTitle: React.FunctionComponent<IChartTitleProps> = ({ title, secondaryTitle }: IChartTitleProps) => {
    return (
        <div style={{ marginBottom: "10px" }}>
            {title && <Typography variant="h6">{title}</Typography>}
            {secondaryTitle && <Typography variant="caption">{secondaryTitle}</Typography>}
        </div>
    );
};

export default ChartTitle;
